import styled from 'styled-components'

const ControlImages = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  position: absolute;
  bottom: 10px;
  width: 100%;
`

export default ControlImages
